import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'
import { mapSearchDtoList } from '../../../mapping/trainees'
import { Trainee } from '../../../types/trainees'

const dataApi = DataApi.getInstance()

export default function useGetSelectedReservationTrainees(
  uuids: string[],
  onSuccess: (data: Trainee[]) => void,
  enabled: boolean
) {
  const texts = useTranslation().t

  const query = useQuery([queryNames.getSelectedReservationTrainees, uuids.join(',')], async () => {
    const { data } = await dataApi.getSelectedReservationTrainees(uuids)
    return mapSearchDtoList(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    enabled: enabled,
    onSuccess: onSuccess,
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })

  return query
}
